import React, { useContext } from 'react';
import { ContextToggle } from '../context/ContextToggle';
import ModernSidebar from './ModernSidebar';

const OffCanvasNav = () => {
  return <ModernSidebar />;
};

export default OffCanvasNav;